import React from 'react';
import data from './active_symbols.json';

class MarketsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      submarkets: []
    }
    this.onChange.bind(this);
  }

  onChange = (e) => {
    this.setState({ value: e.target.value });
    let temp = [];
    if (e.target.value === 'forex') {
      temp = data.active_symbols.filter(m => {
        return m.market_display_name === 'Forex';
      });
    } else if (e.target.value === 'indices') {
      temp = data.active_symbols.filter(m => {
        return m.market_display_name === 'Indices';
      });
    } else {
      temp = []
    }
    this.setState({ submarkets: temp })
  }

  render() {
    let index = 0;
    
    // render submarkets
    const renderOption = opt => (
      <tr key={index++}>
        <td>{opt.display_name}</td>
        <td>{opt.submarket_display_name}</td>
        <td>{opt.symbol}</td>
      </tr>
    )
    
    const isFirefox = typeof InstallTrigger !== 'undefined';   // Firefox 1.0+

    const submarkets = isFirefox === true? [] : this.state.submarkets.map(renderOption)
    
    return (
      <div>
        <h1 className="section-heading">Explore available markets</h1>
        <br />
        <select className="btn btn-default" value={this.state.value} onChange={this.onChange}>
          <option value="">Select a market</option>
          <option value="forex">Forex</option>
          <option value="indices">Indices</option>
        </select>
        <table className="table table-striped">
          <thead>
            <tr>
              <td>Market</td>
              <td>Submarket</td>
              <td>Market symbol</td>
            </tr>
          </thead>
          <tbody>
            {submarkets}
          </tbody>
        </table>
      </div>
    )
  }
}

export default MarketsTable


// WEBPACK FOOTER //
// ./src/components/pages/Markets/MarketsTable.js